import React from 'react'
import cn from 'classnames'

import { Flex, BoxHeadline } from 'shared/ui'

const NoResults = ({ className }) => (
  <Flex
    className={cn('grui my-20 mx-10 items-center justify-center', className)}
  >
    <BoxHeadline>No results found</BoxHeadline>
  </Flex>
)

export default NoResults
